var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack347({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3,
    y: 2.96,
    width: 10,
    height: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.2,10.74V5.37h2a2.11,2.11,0,0,1,.91.15,1.22,1.22,0,0,1,.48.5,1.79,1.79,0,0,1,.18.81,1.49,1.49,0,0,1-.31,1,1.52,1.52,0,0,1-.93.48,1.57,1.57,0,0,1,.38.3,4.26,4.26,0,0,1,.46.68l.76,1.46H7.35L6.77,9.63a6.57,6.57,0,0,0-.52-.89,1,1,0,0,0-.34-.3,1,1,0,0,0-.45-.08H4.79v2.38Zm.59-3H6a1.45,1.45,0,0,0,.62-.1A.78.78,0,0,0,7,7.33a1,1,0,0,0,.12-.49.84.84,0,0,0-.24-.64A.94.94,0,0,0,6.18,6H4.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.45,9,9,9a1.57,1.57,0,0,0,.2.69,1.12,1.12,0,0,0,.44.39,1.38,1.38,0,0,0,.65.15,1.17,1.17,0,0,0,.81-.25.85.85,0,0,0,.29-.66.82.82,0,0,0-.11-.42A.87.87,0,0,0,11,8.57a7.25,7.25,0,0,0-.91-.32,3,3,0,0,1-.89-.37,1.33,1.33,0,0,1-.41-.47,1.38,1.38,0,0,1-.14-.65A1.44,1.44,0,0,1,9,5.69a1.57,1.57,0,0,1,1.13-.41,1.79,1.79,0,0,1,.86.19A1.34,1.34,0,0,1,11.6,6a1.79,1.79,0,0,1,.22.85l-.56,0A1.14,1.14,0,0,0,11,6.16a1.08,1.08,0,0,0-.76-.26,1.1,1.1,0,0,0-.75.23.68.68,0,0,0-.26.57.63.63,0,0,0,.19.5,2.14,2.14,0,0,0,.85.37,5.54,5.54,0,0,1,.92.31,1.54,1.54,0,0,1,.61.54,1.56,1.56,0,0,1,.2.8,1.69,1.69,0,0,1-.21.84,1.56,1.56,0,0,1-.59.58,1.93,1.93,0,0,1-.9.19A1.73,1.73,0,0,1,9,10.34,1.86,1.86,0,0,1,8.45,9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack347);
export default __webpack_public_path__ + "static/media/Symbol_pack_347.1cd82e37f354baa496e2ab8df36fcd09.svg";
export { ForwardRef as ReactComponent };